import { IllegalArgumentError } from '../../sdk/errors';
export class DappMessagesFacade {
    constructor(dappMessageBackends) {
        this.dappMessageBackends = dappMessageBackends;
        if (dappMessageBackends.length < 1) {
            throw new IllegalArgumentError('Expected to have at least one dapp message backend.');
        }
    }
    async send(command) {
        const allSettled = await Promise.allSettled(this.dappMessageBackends.map((it) => it.send(command)));
        const errors = allSettled
            .filter((it) => it.status === 'rejected')
            .map((it) => it)
            .map((it) => it.reason);
        if (errors.length > 0) {
            console.error(`Error during sending dapp messages: ${errors.map((it) => JSON.stringify(it))}`);
        }
        const fulfilled = allSettled.filter((it) => it.status === 'fulfilled');
        if (errors.length > 0 && fulfilled.length === 0) {
            const error = {
                ...errors[0],
                details: errors,
            };
            throw error;
        }
    }
}
//# sourceMappingURL=dapp-messages-facade.js.map